import { render, staticRenderFns } from "./ApplicantReferencesControl.vue?vue&type=template&id=90172372&"
import script from "./ApplicantReferencesControl.vue?vue&type=script&lang=js&"
export * from "./ApplicantReferencesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports